export namespace FormTypeEnum {
  export enum FormType {
    // 活动申请
    ACTIVITY_APPLICATION = 11,
    // 合同返利
    REBATE_INFO = 12,
    // 产品政策
    PRODUCT_POLICY = 13,
    //预排档
    PRE_ACTIVITY = 61,
    // 广告类申请
    ACTIVITY_MKT_APPLICATION = 18,
    // 活动结案
    ACTIVITY_SETTLEMENT = 21,
    // 活动核销
    ACTIVITY_PAYMENT = 31,
    // 预付
    PRE_PAYMENT = 32,
    // 合同返利核销
    CONTRACT_REBATE_PAYMENT = 33,
    // 政策返利核销
    POLICY_REBATE_PAYMENT = 34,
    // 广告类核销
    ACTIVITY_MKT_PAYMENT = 38,
    // 广告类预付
    ACTIVITY_MKT_PRE_PAYMENT = 39,
    // 专项项目
    PROJECT_APPLICATION = 41,
    // 客户合同
    CONTRACT_APPLICATION = 46,
    // 外部费用
    EXPENSE_NON_TPM = 51,
    //预排档
    PRE_SA_APPLICATION = 61,
  }

  export enum PageGroup {
    // 后补类活动申请单
    ACTIVITY_APPLICATION = 1101,
    // 随货类活动申请单
    PRICE_DISCOUNT_APPLICATION = 1111,
    // 免费货类活动申请单
    FREE_GOODS_APPLICATION = 1103,
    // 一级合同返利单
    CONTRACT_REBATE = 1201,
    // 二级合同返利单
    CONTRACT_REBATE_LEVEL_2 = 1202,
    // 政策返利单(常规预提)
    POLICY_REBATE = 1301,
    //系统外返利单
    OTHER_POLICY_REBATE = 1306,
    // 广告类活动申请单
    MKT_APPLICATION = 1801,
    // 后补类活动结案单
    ACTIVITY_SETTLEMENT = 2101,
    /**
     * 通用类活动核销单
     */
    ACTIVITY_PAYMENT = 3101,
    /**
     * 多活动核销
     */
    ACTIVITY_BATCH_PAYMENT = 3151,
    // 预付申请单
    PRE_PAYMENT = 3201,
    // 一级合同返利核销单
    PAYMENT_CONTRACT_REBATE = 3301,
    // 广告类核销 - 正常核销
    PAYMENT_MKT = 3801,
    // 通用类专项申请单
    PROJECT_GENERAL = 4101,
    //客户合同
    CONTRACT_APPLICATION = 4601,
    //合同折扣费用
    NON_TPM_DISCOUNT = 5101,
    //外部费用
    NON_TPM_SPECIAL = 5102,
    // 预提手工调整
    EXPENSE_NON_TPM = 5111,
    // 广告预提手工调整
    EXPENSE_NON_TPM_MKT = 5121,
  }

  export enum PageType {
    // 活动申请单（客户投资类）
    ACTIVITY_APPLICATION = 1101,
    // 随货类活动申请单（本项目不用）
    PRICE_DISCOUNT_APPLICATION = 1111,
    // 免费货申请表单
    FREE_GOODS_APPLICATION = 1103,
    // App试饮派样申请表单
    APP_FREE_GOODS_APPLICATION = 1104,

    // 一级合同返利单
    CONTRACT_REBATE = 1201,

    // 二级合同返利单
    CONTRACT_REBATE_LEVEL_2 = 1202,
    // 政策返利单(常规预提)
    POLICY_REBATE = 1301,
    // 政策返利单(发货预提)
    POLICY_REBATE_DELIVERY = 1302,
    //系统外返利单
    OTHER_POLICY_REBATE = 1306,
    //预排挡申请
    PRE_ACTIVITY = 6101,

    // 广告类活动申请
    MKT_APPLICATION = 1801,
    // 后补类活动结案单
    ACTIVITY_SETTLEMENT = 2101,

    /**
     * 通用类核销 - 账扣/转账
     */
    PAYMENT_ACCOUNT_REDUCE = 3101,
    // 经销商投资类核销单
    PAYMENT_SOLD_TO = 3102,
    /**
     * 通用类核销 - 第三方支付
     */
    PAYMENT_THIRD_PART = 3103,
    // 后补类核销 - 第三方支付冲销
    PAYMENT_THIRD_PART_PRE = 3104,
    /**
     * 通用类核销 - 票扣（3105）
     */
    PAYMENT_BILL_DEDUCT = 3105,
    /**
     * 通用类核销-货补
     */
    PAYMENT_FREE_GOODS = 3107,

    // 后补类核销-通用
    PAYMENT_COMMON = 3111,
    // 后补类核销-费用池
    PAYMENT_TO_POOL = 3112,
    /**
     * 多活动核销 - 账扣/转账（3151）
     */
    PAYMENT_BATCH_ACCOUNT_REDUCE = 3151,
    /**
     * 多活动核销 - 第三方支付（3153）
     */
    PAYMENT_BATCH_THIRD_PART = 3153,
    /**
     * 多活动核销 - 票扣/费用池/货补池/记账（3155）
     */
    PAYMENT_BATCH_BILL_DEDUCT = 3155,

    // 后补类预付申请单
    PRE_PAYMENT_THIRD_PART = 3201,
    // 返利核销单 - 账扣/转账（3301)
    PAYMENT_CONTRACT_ACCOUNT_REDUCE = 3301,
    // 返利核销单 - 第三方支付（3303）
    PAYMENT_CONTRACT_THIRD_PART = 3303,
    // 返利核销单 - 票扣（3305）
    PAYMENT_CONTRACT_BILL_DEDUCT = 3305,
    // 返利核销单 - 费用池/货补池
    PAYMENT_CONTRACT_FREE_GOODS = 3309,
    // 政策返利核销单 - 账扣（3401)
    PAYMENT_POLICY_ACCOUNT_REDUCE = 3401,
    // 政策返利核销单 - 第三方支付（3403）
    PAYMENT_POLICY_THIRD_PART = 3403,
    // 政策返利核销单 - 票扣（3405）
    PAYMENT_POLICY_BILL_DEDUCT = 3405,
    // 政策返利核销单 - 货补（3407）
    PAYMENT_POLICY_FREE_GOODS = 3407,
    // on-invoice返点核销单
    PAYMENT_CONTRACT_ONINVOICE = 3302,
    //广告类核销
    PAYMENT_MKT = 3801,
    // 通用类专项申请单
    PROJECT_GENERAL = 4101,
    //企划类专项申请单
    PROJECT_GENERAL_PLANNING = 4102,
    //客户合同
    CONTRACT_APPLICATION = 4601,
    NON_TPM_DISCOUNT = 5101,
    NON_TPM_SPECIAL = 5102,
    NON_TPM_FG = 5103,
    //费用调整申请单
    POOL_ADJUST_APPLICATION = 6101,
  }
}
